export enum DocumentRule {
  MustHaveEndorsements = "MustHaveEndorsements",
  RequiresReview = "RequiresReview"
}
